enum TabsKeys {
  basic_info = 'basic-info',
  analyses = 'analyses',
  works = 'works',
  total = 'total',
  deals = 'deals',
}

export default TabsKeys;
